import { ApiError } from '@robotensor/api'
import { QueryClient } from '@tanstack/react-query'

/** Retry only what retrying can fix: network blips. Never retry 4xx or a missing endpoint. */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: true,
      retry: (failures, error) => (error instanceof ApiError ? error.code === 'network' && failures < 2 : failures < 1),
      retryDelay: (n) => Math.min(4000, 500 * 2 ** n),
    },
    mutations: { retry: false },
  },
})
